import hasFeature from 'modules/core/lib/hasFeature'
import users from 'modules/core/store/collections/users'

export const hasAccess = () => {
  return hasFeature('one_on_ones') && !!users.current.employee
}
